
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.idb-form--columns-2 form, .idb-form--columns-3 form {

  display: block;
}
    .idb-form--columns-2 form, .idb-form--columns-3 form {

  -moz-column-gap: 3rem;

       column-gap: 3rem;
}
    .idb-form--columns-2 form, .idb-form--columns-3 form {

  row-gap: 0.75rem;
}
    @media (min-width: 768px) {
  .idb-form--columns-2 form, .idb-form--columns-3 form {

    display: grid;
  }
}
    .idb-form--columns-2 form .form-item input, .idb-form--columns-3 form .form-item input {

  max-width: 100%;
}
  .idb-form--columns-3 form {

  grid-template-columns: repeat(3, minmax(0, 1fr));
}
  .idb-form--columns-3 form .form-actions {

  grid-column: span 3 / span 3;
}
  .idb-form--columns-2 form {

  grid-template-columns: repeat(2, minmax(0, 1fr));
}
  .idb-form--columns-2 form .form-actions {

  grid-column: span 2 / span 2;
}

label {

  margin-bottom: 0.75rem;

  display: block;

  font-weight: var(--fw-semibold);

  color: var(--blue-responsible-darken-1);

  font-size: var(--fs-base);

  line-height: var(--lh-base);
}

@media (min-width: 1280px) {
  label {

    font-size: var(--fs-sm);

    line-height: var(--lh-sm);
  }
}

@media (min-width: 1440px) {
  label {

    font-size: var(--fs-base);

    line-height: var(--lh-base);
  }
}

input[type='text'], input[type='email'], input[type='url'], input[type='password'], input[type='number'], input[type='date'], input[type='datetime-local'], input[type='month'], input[type='search'], input[type='tel'], input[type='time'], input[type='week'], textarea, select[multiple], select {

  box-sizing: border-box;

  width: 100%;

  -webkit-appearance: none;

     -moz-appearance: none;

          appearance: none;

  border-radius: 0.375rem;

  border-width: 1px;

  border-style: solid;

  border-color: var(--gray-cosmopolitan-main);

  background-color: var(--neutral-white);

  padding-top: 0.5rem;

  padding-bottom: 0.5rem;

  padding-left: 0.75rem;

  padding-right: 0.75rem;

  font-family: Open Sans, Helvetica, Arial, sans-serif;

  line-height: 1.25rem;

  color: var(--blue-responsible-darken-1);
}

input[type='text'].option, input[type='email'].option, input[type='url'].option, input[type='password'].option, input[type='number'].option, input[type='date'].option, input[type='datetime-local'].option, input[type='month'].option, input[type='search'].option, input[type='tel'].option, input[type='time'].option, input[type='week'].option, textarea.option, select[multiple].option, select.option {

  font-size: var(--fs-xl);

  line-height: var(--lh-xl);
}

@media (min-width: 768px) {
  input[type='text'], input[type='email'], input[type='url'], input[type='password'], input[type='number'], input[type='date'], input[type='datetime-local'], input[type='month'], input[type='search'], input[type='tel'], input[type='time'], input[type='week'], textarea, select[multiple], select {

    width: auto;
  }
}

input[type='text'], input[type='email'], input[type='url'], input[type='password'], input[type='number'], input[type='date'], input[type='datetime-local'], input[type='month'], input[type='search'], input[type='tel'], input[type='time'], input[type='week'], textarea, select[multiple], select {

  font-size: var(--fs-base);

  line-height: var(--lh-base);
}

@media (min-width: 1280px) {
  input[type='text'], input[type='email'], input[type='url'], input[type='password'], input[type='number'], input[type='date'], input[type='datetime-local'], input[type='month'], input[type='search'], input[type='tel'], input[type='time'], input[type='week'], textarea, select[multiple], select {

    font-size: var(--fs-sm);

    line-height: var(--lh-sm);
  }
}

@media (min-width: 1440px) {
  input[type='text'], input[type='email'], input[type='url'], input[type='password'], input[type='number'], input[type='date'], input[type='datetime-local'], input[type='month'], input[type='search'], input[type='tel'], input[type='time'], input[type='week'], textarea, select[multiple], select {

    font-size: var(--fs-base);

    line-height: var(--lh-base);
  }
}

input[type='text'],
input[type='email'],
input[type='url'],
input[type='password'],
input[type='number'],
input[type='date'],
input[type='datetime-local'],
input[type='month'],
input[type='search'],
input[type='tel'],
input[type='time'],
input[type='week'],
textarea,
select[multiple],
select{

  min-height:40px;
}

input[type='text']::-moz-placeholder, input[type='email']::-moz-placeholder, input[type='url']::-moz-placeholder, input[type='password']::-moz-placeholder, input[type='number']::-moz-placeholder, input[type='date']::-moz-placeholder, input[type='datetime-local']::-moz-placeholder, input[type='month']::-moz-placeholder, input[type='search']::-moz-placeholder, input[type='tel']::-moz-placeholder, input[type='time']::-moz-placeholder, input[type='week']::-moz-placeholder, textarea::-moz-placeholder, select[multiple]::-moz-placeholder, select::-moz-placeholder {

  color: var(--gray-cosmopolitan-main);
}

input[type='text']::placeholder, input[type='email']::placeholder, input[type='url']::placeholder, input[type='password']::placeholder, input[type='number']::placeholder, input[type='date']::placeholder, input[type='datetime-local']::placeholder, input[type='month']::placeholder, input[type='search']::placeholder, input[type='tel']::placeholder, input[type='time']::placeholder, input[type='week']::placeholder, textarea::placeholder, select[multiple]::placeholder, select::placeholder {

  color: var(--gray-cosmopolitan-main);
}

input[type='text']:hover, input[type='email']:hover, input[type='url']:hover, input[type='password']:hover, input[type='number']:hover, input[type='date']:hover, input[type='datetime-local']:hover, input[type='month']:hover, input[type='search']:hover, input[type='tel']:hover, input[type='time']:hover, input[type='week']:hover, textarea:hover, select[multiple]:hover, select:hover {

  border-color: var(--blue-responsible-darken-1);
}

input[type='text']:hover, input[type='email']:hover, input[type='url']:hover, input[type='password']:hover, input[type='number']:hover, input[type='date']:hover, input[type='datetime-local']:hover, input[type='month']:hover, input[type='search']:hover, input[type='tel']:hover, input[type='time']:hover, input[type='week']:hover, textarea:hover, select[multiple]:hover, select:hover {

  outline: 2px solid transparent;

  outline-offset: 2px;
}

input[type='text']:focus, input[type='email']:focus, input[type='url']:focus, input[type='password']:focus, input[type='number']:focus, input[type='date']:focus, input[type='datetime-local']:focus, input[type='month']:focus, input[type='search']:focus, input[type='tel']:focus, input[type='time']:focus, input[type='week']:focus, textarea:focus, select[multiple]:focus, select:focus {

  border-color: var(--blue-responsible-darken-1);
}

input[type='text']:focus, input[type='email']:focus, input[type='url']:focus, input[type='password']:focus, input[type='number']:focus, input[type='date']:focus, input[type='datetime-local']:focus, input[type='month']:focus, input[type='search']:focus, input[type='tel']:focus, input[type='time']:focus, input[type='week']:focus, textarea:focus, select[multiple]:focus, select:focus {

  outline: 2px solid transparent;

  outline-offset: 2px;
}

input[type='text']:focus, input[type='email']:focus, input[type='url']:focus, input[type='password']:focus, input[type='number']:focus, input[type='date']:focus, input[type='datetime-local']:focus, input[type='month']:focus, input[type='search']:focus, input[type='tel']:focus, input[type='time']:focus, input[type='week']:focus, textarea:focus, select[multiple]:focus, select:focus{
    box-shadow:var(--brand-shadow);
  }

input[type='text'].error, input[type='email'].error, input[type='url'].error, input[type='password'].error, input[type='number'].error, input[type='date'].error, input[type='datetime-local'].error, input[type='month'].error, input[type='search'].error, input[type='tel'].error, input[type='time'].error, input[type='week'].error, textarea.error, select[multiple].error, select.error {

  border-color: var(--ui-errorText);
}

select {

  background-repeat: no-repeat;

  padding-right: 3.5rem;
  background-position:right 1.25rem center;
  background-image:url("data:image/svg+xml,%3Csvg width='15' height='8' viewBox='0 0 15 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7.81303 7.83121L14.6455 0.979811C14.8692 0.755333 14.8688 0.391897 14.6443 0.167795C14.4198 -0.0561333 14.0562 -0.0555547 13.8323 0.168952L7.40651 6.61254L0.980746 0.16872C0.756818 -0.0557579 0.393412 -0.0563366 0.168904 0.167563C0.0563612 0.279903 8.96267e-05 0.427077 8.96203e-05 0.574251C8.96139e-05 0.721049 0.0559854 0.867644 0.167747 0.979782L7.00003 7.83121C7.10759 7.93933 7.25399 8 7.40651 8C7.55904 8 7.70526 7.93916 7.81303 7.83121Z' fill='%231B365D'/%3E%3C/svg%3E");
}

textarea {

  display: block;
}

input[type='checkbox'], input[type='radio'] {

  float: left;

  margin: 0px;

  box-sizing: border-box;

  cursor: pointer;

  -webkit-appearance: none;

     -moz-appearance: none;

          appearance: none;

  border-width: 2px;

  border-style: solid;

  border-color: var(--gray-professional-lighten-1);

  outline: 2px solid transparent;

  outline-offset: 2px;

  min-width:1.25rem;
  width:25px;
  height:25px;
  margin-top:-2px;
}

input[type='checkbox'] + label, input[type='radio'] + label {

  margin-bottom: 0px;
}

input[type='checkbox'] + label, input[type='radio'] + label {

  margin-top: 0px;
}

input[type='checkbox'] + label, input[type='radio'] + label {

  display: inline-block;
}

input[type='checkbox'] + label, input[type='radio'] + label {

  cursor: pointer;
}

input[type='checkbox'] + label, input[type='radio'] + label {

  padding-left: 0.75rem;
}

input[type='checkbox'] + label, input[type='radio'] + label {

  color: var(--gray-professional-lighten-1);
}

input[type='checkbox'].error, input[type='radio'].error {

  border-color: var(--ui-errorText);
}

input[type='checkbox'] {

  position: relative;

  border-radius: 0.25rem;

  background-color: var(--neutral-white);
}

input[type='checkbox']:checked {

  position: relative;
}

input[type='checkbox']:checked {

  border-color: var(--blue-responsible-main);
}

input[type='checkbox']:checked {

  background-color: var(--blue-responsible-main);
}

input[type='checkbox']:checked {

  color: var(--neutral-white);
}

input[type='checkbox']:checked::before {

  position: absolute;
}

input[type='checkbox']:checked::before {

  left: 50%;
}

input[type='checkbox']:checked::before {

  top: 50%;
}

input[type='checkbox']:checked::before {

  display: block;
}

input[type='checkbox']:checked::before {

  height: 0.5rem;
}

input[type='checkbox']:checked::before {

  width: 1rem;
}

input[type='checkbox']:checked::before {

  border-width: 1px;
}

input[type='checkbox']:checked::before {

  border-top-width: 0px;
}

input[type='checkbox']:checked::before {

  border-bottom-width: 2px;
}

input[type='checkbox']:checked::before {

  border-left-width: 2px;
}

input[type='checkbox']:checked::before {

  border-right-width: 0px;
}

input[type='checkbox']:checked::before {

  border-style: solid;
}

input[type='checkbox']:checked::before {

  border-color: var(--neutral-white);
}

input[type='checkbox']:checked::before{
      content:'';
      transform:translate(-50%, -60%) rotate(-45deg);
    }

input[type='checkbox'].error:checked {

  border-color: var(--ui-errorText);
}

input[type='checkbox'].error:checked {

  background-color: var(--neutral-white);
}

input[type='checkbox'].error:checked::before {

  border-color: var(--ui-errorText);
}

input[type='radio'] {

  display: inline-flex;

  cursor: pointer;

  align-items: center;

  justify-content: center;

  border-radius: 9999px;

  color: var(--neutral-white);

  outline: 2px solid transparent;

  outline-offset: 2px;
}

input[type='radio']::before {

  display: block;
}

input[type='radio']::before {

  border-radius: 9999px;
}

input[type='radio']::before{

    content:'';
    width:15px;
    height:15px;
  }

input[type='radio']:checked {

  border-color: var(--blue-responsible-main);
}

input[type='radio']:checked::before {

  background-color: var(--blue-responsible-main);
}

input[type='radio'].error:checked {

  border-color: var(--ui-errorText);
}

input[type='radio'].error:checked::before {

  background-color: var(--ui-errorText);
}

input[type='file'] {

  font-size: var(--fs-base);

  line-height: var(--lh-base);
}

@media (min-width: 1280px) {
  input[type='file'] {

    font-size: var(--fs-sm);

    line-height: var(--lh-sm);
  }
}

@media (min-width: 1440px) {
  input[type='file'] {

    font-size: var(--fs-base);

    line-height: var(--lh-base);
  }
}

input[type='date'] {

  text-align: right;
}

fieldset {

  margin: 0px;

  border-style: none;

  padding: 0px;
}

legend {

  margin-bottom: 0.75rem;

  font-weight: var(--fw-semibold);
}

[type='submit'] {

  display: flex;

  cursor: pointer;

  align-items: center;

  border-width: 1px;

  border-style: solid;

  border-color: var(--blue-responsible-main);

  background-color: var(--blue-responsible-main);

  padding-left: 1rem;

  padding-right: 1rem;

  padding-top: 0.5rem;

  padding-bottom: 0.5rem;

  text-align: center;

  font-family: Open Sans, Helvetica, Arial, sans-serif;

  font-weight: var(--fw-semibold);

  line-height: 1.25;

  color: var(--neutral-white);

  transition-property: color, background-color, border-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-text-decoration-color, -webkit-backdrop-filter;

  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;

  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-text-decoration-color, -webkit-backdrop-filter;

  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);

  transition-duration: 300ms;
}

[type='submit'].option {

  font-size: var(--fs-xl);

  line-height: var(--lh-xl);
}

[type='submit'] {

  font-size: var(--fs-lg);

  line-height: var(--lh-lg);
}

@media (min-width: 1280px) {
  [type='submit'] {

    font-size: var(--fs-base);

    line-height: var(--lh-base);
  }
}

@media (min-width: 1440px) {
  [type='submit'] {

    font-size: var(--fs-lg);

    line-height: var(--lh-lg);
  }
}

[type='submit']{

  border-radius:10px;
}

[type='submit']:hover, [type='submit']:focus {

  cursor: pointer;
}

[type='submit']:hover, [type='submit']:focus {

  background-color: var(--neutral-white);
}

[type='submit']:hover, [type='submit']:focus {

  color: var(--blue-responsible-main);
}

[type='submit'].secondary {

  background-color: var(--neutral-white);
}

[type='submit'].secondary {

  color: var(--blue-responsible-main);
}

[type='submit'].secondary:hover, [type='submit'].secondary:focus {

  cursor: pointer;
}

[type='submit'].secondary:hover, [type='submit'].secondary:focus {

  background-color: var(--blue-responsible-main);
}

[type='submit'].secondary:hover, [type='submit'].secondary:focus {

  color: var(--neutral-white);
}

[type='submit'].tertiary {

  border-top-color: var(--green-guarantee-lighten-2);
}

[type='submit'].tertiary {

  background-color: var(--green-guarantee-lighten-3);
}

[type='submit'].tertiary {

  color: var(--neutral-white);
}

[type='submit'].tertiary:hover, [type='submit'].tertiary:focus {

  cursor: pointer;
}

[type='submit'].tertiary:hover, [type='submit'].tertiary:focus {

  background-color: var(--neutral-white);
}

[type='submit'].tertiary:hover, [type='submit'].tertiary:focus {

  color: var(--green-guarantee-darken-2);
}

input[data-icon],
input[type='search']{
  background-repeat:no-repeat;
  background-position:10px center;
  background-size:20px auto;
  padding-left:40px;
  padding-right:120px;
}

input[data-icon='search'],
input[type='search']{
  background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'%3E%3Cpath d='M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z' stroke='%23004E70' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M19 19L14.65 14.65' stroke='%23004E70' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
}

input[data-icon='download']{
  background-image:url("data:image/svg+xml,%3Csvg fill='none' height='20' viewBox='0 0 21 20' width='21' xmlns='http://www.w3.org/2000/svg'%3E%3Cg stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'%3E%3Cpath d='m17.75 12.5v3.3333c0 .4421-.1756.866-.4882 1.1785-.3125.3126-.7364.4882-1.1785.4882h-11.66663c-.44203 0-.86595-.1756-1.17851-.4882-.31257-.3125-.48816-.7364-.48816-1.1785v-3.3333'/%3E%3Cpath d='m6.08398 8.33398 4.16672 4.16672 4.1666-4.16672'/%3E%3Cpath d='m10.25 12.5v-10'/%3E%3C/g%3E%3C/svg%3E");
}

input[data-icon='download']:hover,
  input[data-icon='download']:focus{
    background-image:url("data:image/svg+xml,%3Csvg fill='none' height='20' viewBox='0 0 21 20' width='21' xmlns='http://www.w3.org/2000/svg'%3E%3Cg stroke='%2300374e' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'%3E%3Cpath d='m17.75 12.5v3.3333c0 .4421-.1756.866-.4882 1.1785-.3125.3126-.7364.4882-1.1785.4882h-11.66663c-.44203 0-.86595-.1756-1.17851-.4882-.31257-.3125-.48816-.7364-.48816-1.1785v-3.3333'/%3E%3Cpath d='m6.08398 8.33398 4.16672 4.16672 4.1666-4.16672'/%3E%3Cpath d='m10.25 12.5v-10'/%3E%3C/g%3E%3C/svg%3E");
  }

input[data-icon='briefcase'], select[data-icon='briefcase']{
  background-image:url("data:image/svg+xml,%3Csvg fill='none' height='20' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'%3E%3Cg stroke='%23004E70' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'%3E%3Crect x='2' y='7' width='20' height='14' rx='2' ry='2'/%3E%3Cpath d='M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16'/%3E%3C/g%3E%3C/svg%3E"),  url("data:image/svg+xml,%3Csvg width='15' height='8' viewBox='0 0 15 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7.81303 7.83121L14.6455 0.979811C14.8692 0.755333 14.8688 0.391897 14.6443 0.167795C14.4198 -0.0561333 14.0562 -0.0555547 13.8323 0.168952L7.40651 6.61254L0.980746 0.16872C0.756818 -0.0557579 0.393412 -0.0563366 0.168904 0.167563C0.0563612 0.279903 8.96267e-05 0.427077 8.96203e-05 0.574251C8.96139e-05 0.721049 0.0559854 0.867644 0.167747 0.979782L7.00003 7.83121C7.10759 7.93933 7.25399 8 7.40651 8C7.55904 8 7.70526 7.93916 7.81303 7.83121Z' fill='%231B365D'/%3E%3C/svg%3E");
  background-position:10px center, right 1.25rem center;
  padding-left:40px;
  padding-right:3.5rem;
}

input[data-icon='calendar'] {

  display: flex;

  width: 100%;

  text-align: left;
}

input[data-icon='location'] {

  padding-right: 0px;
  background-image:url("data:image/svg+xml,%3Csvg width='1em' height='1em' viewBox='0 0 16 16' fill='%23004E70' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' d='M12.166 8.94C12.696 7.867 13 6.862 13 6A5 5 0 0 0 3 6c0 .862.305 1.867.834 2.94.524 1.062 1.234 2.12 1.96 3.07A31.481 31.481 0 0 0 8 14.58l.208-.22a31.493 31.493 0 0 0 1.998-2.35c.726-.95 1.436-2.008 1.96-3.07zM8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10z'/%3E%3Cpath fill-rule='evenodd' d='M8 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6z'/%3E%3C/svg%3E");
}

.jobs-filters.inline .form-actions {

  flex-direction: column;

  align-items: center;
}

@media (min-width: 768px) {
  .jobs-filters.inline .form-actions {

    flex-direction: row;
  }
}

.jobs-filters .form-item-row .form-item, .jobs-filters .form-item-row input {

  width: 100%;

  max-width: 100%;
}

.jobs-filters .search {

  display: contents;
}

@media (min-width: 768px) {
  .jobs-filters .search {

    display: block;
  }
}

.align-bottom .form-item-row {

  align-items: flex-end;
}

select[disabled], select[disabled]:hover, input[disabled], input[disabled]:hover, textarea[disabled], textarea[disabled]:hover {

  cursor: not-allowed;

  border-color: var(--gray-cosmopolitan-main);

  background-color: var(--gray-cosmopolitan-lighten-4);

  color: var(--gray-cosmopolitan-darken-1);
}

select[disabled]::-moz-placeholder, select[disabled]:hover::-moz-placeholder, input[disabled]::-moz-placeholder, input[disabled]:hover::-moz-placeholder, textarea[disabled]::-moz-placeholder, textarea[disabled]:hover::-moz-placeholder {

  color: var(--gray-professional-main);
}

select[disabled]::placeholder, select[disabled]:hover::placeholder, input[disabled]::placeholder, input[disabled]:hover::placeholder, textarea[disabled]::placeholder, textarea[disabled]:hover::placeholder {

  color: var(--gray-professional-main);
}

select[disabled]{
  background-image:url("data:image/svg+xml,%3Csvg width='15' height='8' viewBox='0 0 15 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7.81303 7.83121L14.6455 0.979811C14.8692 0.755333 14.8688 0.391897 14.6443 0.167795C14.4198 -0.0561333 14.0562 -0.0555547 13.8323 0.168952L7.40651 6.61254L0.980746 0.16872C0.756818 -0.0557579 0.393412 -0.0563366 0.168904 0.167563C0.0563612 0.279903 8.96267e-05 0.427077 8.96203e-05 0.574251C8.96139e-05 0.721049 0.0559854 0.867644 0.167747 0.979782L7.00003 7.83121C7.10759 7.93933 7.25399 8 7.40651 8C7.55904 8 7.70526 7.93916 7.81303 7.83121Z' fill='%23B3B5B8'/%3E%3C/svg%3E");
}

input[type='checkbox'][disabled] + label, input[type='radio'][disabled] + label {

  color: var(--gray-professional-main);
}

input[type='checkbox'][disabled]:checked {

  border-color: var(--gray-cosmopolitan-main);

  background-color: var(--gray-cosmopolitan-main);
}

input[type='radio'][disabled]:checked {

  border-color: var(--gray-cosmopolitan-main);
}

input[type='radio'][disabled]:checked::before {

  background-color: var(--gray-cosmopolitan-main);
}

[type='submit'][disabled] {

  border-color: var(--gray-cosmopolitan-lighten-2);

  background-color: var(--gray-cosmopolitan-lighten-2);

  color: var(--neutral-white);
}

[type='submit'][disabled]:hover, [type='submit'][disabled]:focus {

  border-color: var(--gray-cosmopolitan-lighten-2);
}

[type='submit'][disabled]:hover, [type='submit'][disabled]:focus {

  background-color: var(--gray-cosmopolitan-lighten-2);
}

[type='submit'][disabled]:hover, [type='submit'][disabled]:focus {

  color: var(--neutral-white);
}

[type='submit'][disabled].secondary {

  border-color: var(--gray-cosmopolitan-main);
}

[type='submit'][disabled].secondary {

  background-color: var(--neutral-white);
}

[type='submit'][disabled].secondary {

  color: var(--gray-cosmopolitan-main);
}

[type='submit'][disabled].secondary:hover, [type='submit'][disabled].secondary:focus {

  border-color: var(--gray-cosmopolitan-main);
}

[type='submit'][disabled].secondary:hover, [type='submit'][disabled].secondary:focus {

  color: var(--gray-cosmopolitan-main);
}

input[readonly], textarea[readonly] {

  background-color: var(--gray-cosmopolitan-lighten-4);
}

.form-item, .form-actions {

  margin-bottom: 2rem;

  width: 100%;
}

@media (min-width: 768px) {
  .form-item, .form-actions {

    width: auto;
  }
}

.form-item select {

  width: 100%;
}

.form-item .form-item {

  margin-bottom: 1rem;
}

.form-item .form-item:last-child {

  margin-bottom: 0px;
}

.form-actions {

  display: flex;

  flex-wrap: wrap;

  justify-content: center;
}

@media (min-width: 768px) {
  .form-actions {

    flex-wrap: nowrap;
  }
  .form-actions {

    justify-content: flex-start;
  }
}

.form-actions [type='submit'] {

  margin-bottom: 1.75rem;
}

@media (min-width: 768px) {
  .form-actions [type='submit'] {

    margin-right: 1rem;
  }
}

@media (min-width: 768px) {
  .form-actions [type='submit'] {

    margin-bottom: 0px;
  }
}

.form-actions [type='submit']:last-child {

  margin-right: 0px;
}

.form-actions [type='submit']:last-child {

  margin-bottom: 0px;
}

@media (min-width: 768px) {
  .form-actions--justify-center {

    justify-content: center;
  }
}

.visually-hidden{
  position:absolute;
  width:1px;
  height:1px;
  padding:0;
  margin:-1px;
  overflow:hidden;
  clip:rect(0, 0, 0, 0);
  white-space:nowrap;
  border-width:0;
}

.inline {

  display: flex;

  flex-wrap: wrap;
}

@media (min-width: 1440px) {
  .inline {

    flex-wrap: nowrap;
  }
}

.inline .form-actions {

  align-items: flex-end;
}

@media (min-width: 768px) {
  .inline .form-item {

    margin-right: 1.75rem;
  }
}

.inline .form-item--flex-1 {

  flex: 1 1 0%;
}

.inline .form-item--flex-1 input {

  width: 100%;
}

.single .form-item {

  margin-bottom: 0px;
}

.error-message {

  margin-top: 0.75rem;

  display: flex;

  align-items: center;

  color: var(--ui-errorText);
}

.error-message::before {

  margin-right: 0.5rem;
}

.error-message::before {

  display: block;
}

.error-message::before {

  height: 1.25rem;
}

.error-message::before {

  width: 1.25rem;
}

.error-message::before{
    content:'';
    background-image:url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10 1.29032C14.7831 1.29032 18.7097 5.16431 18.7097 10C18.7097 14.8101 14.8141 18.7097 10 18.7097C5.19177 18.7097 1.29032 14.816 1.29032 10C1.29032 5.19343 5.18556 1.29032 10 1.29032ZM10 0C4.47754 0 0 4.47915 0 10C0 15.5241 4.47754 20 10 20C15.5225 20 20 15.5241 20 10C20 4.47915 15.5225 0 10 0ZM9.53669 4.83871H10.4633C10.7384 4.83871 10.9582 5.06782 10.9467 5.34274L10.6645 12.1169C10.6537 12.3761 10.4404 12.5806 10.181 12.5806H9.81895C9.55956 12.5806 9.34629 12.3761 9.33548 12.1169L9.05323 5.34274C9.04181 5.06782 9.26157 4.83871 9.53669 4.83871ZM10 13.3871C9.37645 13.3871 8.87097 13.8926 8.87097 14.5161C8.87097 15.1397 9.37645 15.6452 10 15.6452C10.6235 15.6452 11.129 15.1397 11.129 14.5161C11.129 13.8926 10.6235 13.3871 10 13.3871Z' fill='%23991B1B'/%3E%3C/svg%3E");
    background-size:100%;
  }

.form-item__description {

  margin-top: 0.75rem;

  color: var(--gray-professional-lighten-1);

  font-size: var(--fs-base);

  line-height: var(--lh-base);
}

@media (min-width: 1280px) {
  .form-item__description {

    font-size: var(--fs-sm);

    line-height: var(--lh-sm);
  }
}

@media (min-width: 1440px) {
  .form-item__description {

    font-size: var(--fs-base);

    line-height: var(--lh-base);
  }
}

.form-item--order-first {

  order: -9999;
}

.form-item--order-second{
  order:-2;
}

.exposed-form {

  flex-wrap: wrap !important;

  border-radius: 0.75rem !important;

  padding-left: 1.75rem !important;

  padding-right: 1.75rem !important;

  padding-top: 1.75rem !important;
}

.exposed-form.shadow{
    box-shadow:var(--brand-shadow);
  }

.exposed-form .form-item:first-child {

  width: 100%;
}

.exposed-form .form-item:first-child input {

  width: 100%;
}

.exposed-form [type='submit']:hover {

  cursor: pointer;
}

.exposed-form [type='submit']{

    background-color:var(--outline-btn--primary-bg-color-default);
    color:var(--outline-btn--primary-text-color-default);
    border:var(--outline-btn--primary-border-default);
    outline:var(--outline-btn--primary-outline-default);
    font-weight:var(--outline-btn--primary-weight-default);
  }

.exposed-form [type='submit']:hover{
      background-color:var(--outline-btn--primary-bg-color-hover);
      color:var(--outline-btn--primary-text-color-hover);
      border:var(--outline-btn--primary-border-hover);
      outline:var(--outline-btn--primary-outline-hover);
      font-weight:var(--outline-btn--primary-weight-hover);
    }

.exposed-form [type='submit']:focus{
      background-color:var(--outline-btn--primary-bg-color-focus);
      color:var(--outline-btn--primary-text-color-focus);
      border:var(--outline-btn--primary-border-focus);
      outline:var(--outline-btn--primary-outline-focus);
      font-weight:var(--outline-btn--primary-weight-focus);
    }

.exposed-form [type='submit'].secondary{
      padding:var(--outline-btn--secondary-padding);
      border-radius:var(--outline-btn--secondary-rounded);
      background-color:var(--outline-btn--secondary-bg-color-default);
      color:var(--outline-btn--secondary-text-color-default);
      border:var(--outline-btn--secondary-border-default);
      outline:var(--outline-btn--secondary-outline-default);
      font-weight:var(--outline-btn--secondary-weight-default);
    }

.exposed-form [type='submit'].secondary:hover{
        background-color:var(--outline-btn--secondary-bg-color-hover);
        color:var(--outline-btn--secondary-text-color-hover);
        border:var(--outline-btn--secondary-border-hover);
        outline:var(--outline-btn--secondary-outline-hover);
        font-weight:var(--outline-btn--secondary-weight-hover);
      }

.exposed-form [type='submit'].secondary:focus{
        background-color:var(--outline-btn--secondary-bg-color-focus);
        color:var(--outline-btn--secondary-text-color-focus);
        border:var(--outline-btn--secondary-border-focus);
        outline:var(--outline-btn--secondary-outline-focus);
        font-weight:var(--outline-btn--secondary-weight-focus);
      }

.form-item-row{
  display:flex;
  flex-wrap:wrap;
  align-items:center;
}

.form-item-row select{
  width:auto;
  min-width:100%;
}

.form-item-row .form-item{
  flex:1;
}

@media (max-width: 1366px) and (max-height: 768px){
  .form-item-row .form-item{
    min-width:150px;
  }

  .form-item-row select{
    max-width:100%
  }

}

@media (max-width: 760px){
  .form-item-row .form-item{
    flex:0 0 100%;
    width:100px;
  }

  .form-item-row select{
    max-width:100%
  }
  .form-item, .form-actions{
    margin-bottom:1rem;
  }
}

.idb-search-project.inline {

  display: flex;

  flex-wrap: wrap;

  align-content: center;

  justify-content: center;
}

@media (min-width: 768px) {
  .idb-search-project.inline {

    flex-wrap: nowrap;
  }
}

.idb-search-project.inline .form-item {

  width: 55%;
}

@media (min-width: 768px) {
  .idb-search-project.inline .form-item {

    margin-right: 1.75rem;
  }
}

.idb-search-project.inline .form-item input[type='text'] {

  width: 100%;
}

.idb-search-project.inline .form-item .form-submit {

  width: 100%;
}

.idb-search-form.inline label {

  position: absolute;

  width: 1px;

  height: 1px;

  padding: 0;

  margin: -1px;

  overflow: hidden;

  clip: rect(0, 0, 0, 0);

  white-space: nowrap;

  border-width: 0;
}

.idb-search-form.inline .form-actions [type='submit'] {

  margin-right: 1rem;
}

.idb-search-form.inline [type='submit'][value='Reset']:last-child {

  margin-bottom: 1.75rem;
}

.idb-search-form.inline [type='submit'][value='Reset']:last-child {

  border-width: 0px;
}

.idb-search-form.inline [type='submit'][value='Reset']:last-child {

  background-color: var(--neutral-transparent);
}

.idb-search-form.inline [type='submit'][value='Reset']:last-child {

  font-weight: var(--fw-bold);
}

.idb-search-form.inline [type='submit'][value='Reset']:last-child {

  text-transform: uppercase;
}

.idb-search-form.inline [type='submit'][value='Reset']:last-child {

  color: var(--blue-responsible-main);
}

.idb-search-form.inline [type='submit'][value='Reset']:last-child:hover {

  color: var(--blue-responsible-darken-2);
}

.idb-search-form.inline [type='submit'][value='Reset']:last-child {

  font-size: var(--fs-sm);

  line-height: var(--lh-sm);
}

@media (min-width: 1280px) {
  .idb-search-form.inline [type='submit'][value='Reset']:last-child {

    font-size: var(--fs-xs);

    line-height: var(--lh-xs);
  }
}

@media (min-width: 1440px) {
  .idb-search-form.inline [type='submit'][value='Reset']:last-child {

    font-size: var(--fs-sm);

    line-height: var(--lh-sm);
  }
}

@media (min-width: 768px){
    .idb-search-form.inline input[type='text'], .idb-search-form.inline select {

    width: 100%;
  }
    .idb-search-form.inline input[type='text'],
    .idb-search-form.inline select{
      height:60px;
    }
    .idb-search-form.inline .js-form-item-type {

    width: 20%;
  }
    .idb-search-form.inline .js-form-item-query {

    margin-right: 0px;
  }
    .idb-search-form.inline .js-form-item-query {

    width: 80%;
  }
    .idb-search-form.inline .form-actions {

    position: absolute;
  }
    .idb-search-form.inline .form-actions {

    right: 0px;
  }
    .idb-search-form.inline .form-actions{
      top:10px;
    }
      .idb-search-form.inline .form-actions [type='submit'][value='Reset']:last-child {

    position: absolute;
  }
      .idb-search-form.inline .form-actions [type='submit'][value='Reset']:last-child {

    height: auto;
  }
      .idb-search-form.inline .form-actions [type='submit'][value='Reset']:last-child {

    width: auto;
  }
      .idb-search-form.inline .form-actions [type='submit'][value='Reset']:last-child {

    padding: 0px;
  }
      .idb-search-form.inline .form-actions [type='submit'][value='Reset']:last-child{
        right:-68px;
        top:10px;
      }
}

.idb-search-documents-form.inline{
  justify-content:space-evenly;
  align-items:center;
}

.idb-search-documents-form.inline .form-item {

  margin: 0px;
}

.idb-search-documents-form.inline .form-actions{
    position:inherit;
  }

.idb-search-documents-form.inline .form-actions {

  margin: 0px;
}

.banner-search {

  flex-wrap: wrap;

  border-radius: 0.75rem;
}

.banner-search .banner-search-wrapper {

  box-sizing: border-box;
}

.banner-search .banner-search-wrapper {

  display: grid;
}

.banner-search .banner-search-wrapper {

  width: 100%;
}

.banner-search .banner-search-wrapper {

  -webkit-appearance: none;

     -moz-appearance: none;

          appearance: none;
}

.banner-search .banner-search-wrapper {

  justify-content: space-between;
}

.banner-search .banner-search-wrapper {

  border-radius: 0.375rem;
}

.banner-search .banner-search-wrapper {

  border-width: 1px;
}

.banner-search .banner-search-wrapper {

  border-style: solid;
}

.banner-search .banner-search-wrapper {

  border-color: var(--gray-cosmopolitan-main);
}

.banner-search .banner-search-wrapper {

  background-color: var(--neutral-white);
}

.banner-search .banner-search-wrapper {

  padding-top: 0.5rem;

  padding-bottom: 0.5rem;
}

.banner-search .banner-search-wrapper {

  padding-left: 0.75rem;

  padding-right: 0.75rem;
}

.banner-search .banner-search-wrapper {

  font-family: Open Sans, Helvetica, Arial, sans-serif;
}

.banner-search .banner-search-wrapper {

  font-size: var(--fs-base);

  line-height: var(--lh-base);
}

.banner-search .banner-search-wrapper {

  line-height: 1.25rem;
}

.banner-search .banner-search-wrapper {

  color: var(--blue-responsible-darken-1);
}

.banner-search .banner-search-wrapper.option {

  font-size: var(--fs-xl);

  line-height: var(--lh-xl);
}

@media (min-width: 768px) {
  .banner-search .banner-search-wrapper {

    width: auto;
  }
}

.banner-search .banner-search-wrapper {

  font-size: var(--fs-base);

  line-height: var(--lh-base);
}

@media (min-width: 1280px) {
  .banner-search .banner-search-wrapper {

    font-size: var(--fs-sm);

    line-height: var(--lh-sm);
  }
}

@media (min-width: 1440px) {
  .banner-search .banner-search-wrapper {

    font-size: var(--fs-base);

    line-height: var(--lh-base);
  }
}

.banner-search .banner-search-wrapper{

    height:60px;
    grid-template-columns:7fr 1fr;
    justify-items:start;
    grid-column-end:span 7fr;
  }

.banner-search .banner-search-wrapper .banner-search-input-search{
      grid-column:1 / span 6;
      width:100%;
    }

.banner-search .banner-search-wrapper .button {

  height: 40px;
}

.banner-search .banner-search-wrapper input[type='text'] {

  width: 100%;
}

.banner-search .banner-search-wrapper input[type='text'] {

  -webkit-appearance: none;

     -moz-appearance: none;

          appearance: none;
}

.banner-search .banner-search-wrapper input[type='text'] {

  border-radius: 0.375rem;
}

.banner-search .banner-search-wrapper input[type='text'] {

  border-style: none;
}

.banner-search .banner-search-wrapper input[type='text'] {

  background-color: var(--neutral-white);
}

.banner-search .banner-search-wrapper input[type='text'] {

  padding-top: 0.5rem;

  padding-bottom: 0.5rem;
}

.banner-search .banner-search-wrapper input[type='text'] {

  padding-right: 0.75rem;
}

.banner-search .banner-search-wrapper input[type='text'] {

  font-family: Open Sans, Helvetica, Arial, sans-serif;
}

.banner-search .banner-search-wrapper input[type='text'] {

  line-height: 1.25rem;
}

.banner-search .banner-search-wrapper input[type='text'] {

  color: var(--blue-responsible-darken-1);
}

.banner-search .banner-search-wrapper input[type='text'].option {

  font-size: var(--fs-xl);

  line-height: var(--lh-xl);
}

@media (min-width: 768px) {
  .banner-search .banner-search-wrapper input[type='text'] {

    width: auto;
  }
}

.banner-search .banner-search-wrapper input[type='text'] {

  font-size: var(--fs-base);

  line-height: var(--lh-base);
}

@media (min-width: 1280px) {
  .banner-search .banner-search-wrapper input[type='text'] {

    font-size: var(--fs-sm);

    line-height: var(--lh-sm);
  }
}

@media (min-width: 1440px) {
  .banner-search .banner-search-wrapper input[type='text'] {

    font-size: var(--fs-base);

    line-height: var(--lh-base);
  }
}

.banner-search .banner-search-wrapper input[type='text']{
      height:40px;
    }

@media (min-width: 640px) {
  .banner-search .banner-search-wrapper input[type='text']input[type='submit']= {

    display: none;
  }
}

.banner-search .banner-search-wrapper input[type='text']::-moz-placeholder {

  color: var(--gray-cosmopolitan-main);
}

.banner-search .banner-search-wrapper input[type='text']::placeholder {

  color: var(--gray-cosmopolitan-main);
}

.banner-search .banner-search-wrapper input[type='text']:hover {

  border-color: var(--blue-responsible-darken-1);
}

.banner-search .banner-search-wrapper input[type='text']:hover {

  outline: 2px solid transparent;

  outline-offset: 2px;
}

.banner-search .banner-search-wrapper input[type='text']:focus {

  border-color: var(--blue-responsible-darken-1);
}

.banner-search .banner-search-wrapper input[type='text']:focus {

  outline: 2px solid transparent;

  outline-offset: 2px;
}

.banner-search .banner-search-wrapper input[type='text']:focus{
        box-shadow:var(--brand-shadow);
      }

.banner-search .banner-search-wrapper input[type='text'].error {

  border-color: var(--ui-errorText);
}

@media (max-width: 768px){
      .banner-search .banner-search-wrapper .form-actions {

    flex-wrap: nowrap;
  }
      .banner-search .banner-search-wrapper .form-actions {

    gap: 0.125rem;
  }
    }

@media (max-width: 475px){

      .banner-search .banner-search-wrapper input[type='submit'].form-submit{
        width:35px;
        height:35px;
        background-size:contain;
        background-repeat:no-repeat;
        display:inline-block;
        color:transparent;
      }

      .banner-search .banner-search-wrapper .form-actions input[type='submit']:first-child{
        background-image:url("data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20height%3D%2224px%22%20viewBox%3D%220%20-480%20480%20480%22%20width%3D%2224px%22%20fill%3D%22%23fff%22%3E%3Cpath%20d%3D%22M235.385%20-100q-6.575%200%20-10.98%20-4.405t-4.405%20-10.98v-111.54L110.5%20-365.575q-3.925%20-4.27%20-1.04%20-9.35%202.885%20-5.075%208%20-5.075h245.08q5.115%200%208%205.075%202.885%205.08%20-1.04%209.35L260%20-226.925v111.54q0%206.575%20-4.405%2010.98t-10.981%204.405zM240%20-226.46l108.845%20-138.155H131.155zm0%200%22%2F%3E%3C%2Fsvg%3E");
      }

      .banner-search .banner-search-wrapper .form-actions input[type='submit']:last-child{
        background-image:url("data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20height%3D%2224px%22%20viewBox%3D%220%20-960%20960%20960%22%20width%3D%2224px%22%20fill%3D%22%23fff%22%3E%3Cpath%20d%3D%22M563.54-509.46%20535-538l143-182H353l-40-40h406.23q12.69%200%2018.69%2011.23%206%2011.23-2.07%2022L563.54-509.46Zm229.77%20399.61L520-383.15v152.38q0%2013.15-8.81%2021.96T489.23-200h-18.46q-13.15%200-21.96-8.81T440-230.77v-232.38L109.85-793.31l28.3-28.54%20683.7%20683.7-28.54%2028.3ZM535-538Z%22%2F%3E%3C%2Fsvg%3E");
      }

      .banner-search .banner-search-wrapper .form-actions input[type='submit']:only-of-type{
        background-image:url("data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20height%3D%2224px%22%20viewBox%3D%220%20-480%20480%20480%22%20width%3D%2224px%22%20fill%3D%22%23fff%22%3E%3Cpath%20d%3D%22M235.385%20-100q-6.575%200%20-10.98%20-4.405t-4.405%20-10.98v-111.54L110.5%20-365.575q-3.925%20-4.27%20-1.04%20-9.35%202.885%20-5.075%208%20-5.075h245.08q5.115%200%208%205.075%202.885%205.08%20-1.04%209.35L260%20-226.925v111.54q0%206.575%20-4.405%2010.98t-10.981%204.405zM240%20-226.46l108.845%20-138.155H131.155zm0%200%22%2F%3E%3C%2Fsvg%3E");
      }

    }

.banner-search .banner-search-wrapper.shadow{
      box-shadow:var(--brand-shadow);
    }

.banner-search .banner-search-wrapper::after{
      order:-1;
    }

.banner-search .banner-search-wrapper .search-button {

  justify-content: flex-end;
}

.banner-search .banner-search-wrapper::-moz-placeholder {

  color: var(--gray-cosmopolitan-main);
}

.banner-search .banner-search-wrapper::placeholder {

  color: var(--gray-cosmopolitan-main);
}

.banner-search .banner-search-wrapper:hover {

  border-color: var(--blue-responsible-darken-1);
}

.banner-search .banner-search-wrapper:hover {

  outline: 2px solid transparent;

  outline-offset: 2px;
}

.banner-search .banner-search-wrapper:focus {

  border-color: var(--blue-responsible-darken-1);
}

.banner-search .banner-search-wrapper:focus {

  outline: 2px solid transparent;

  outline-offset: 2px;
}

.banner-search .banner-search-wrapper:focus{
      box-shadow:var(--brand-shadow);
    }

.banner-search .banner-search-wrapper.error {

  border-color: var(--ui-errorText);
}

.idb-salesforce-form {

  background-color: var(--blue-responsible-lighten-5);

  padding: 2.5rem;
}

.idb-salesforce-form input[type='text'], .idb-salesforce-form input[type='email'], .idb-salesforce-form select, .idb-salesforce-form textarea {

  width: 100%;
}

.idb-salesforce-form input[type='text'], .idb-salesforce-form input[type='email'], .idb-salesforce-form select, .idb-salesforce-form textarea {

  font-size: var(--fs-lg);

  line-height: var(--lh-lg);
}

.idb-salesforce-form .font-body.option {

  font-size: var(--fs-xl);

  line-height: var(--lh-xl);
}

.idb-salesforce-form input[type='submit'] {

  height: 5rem;
}

.idb-salesforce-form input[type='submit'] {

  width: 60%;
}

.idb-salesforce-form input[type='submit'] {

  justify-content: center;
}

.idb-salesforce-form input[type='submit'] {

  border-radius: 0px;
}

.idb-salesforce-form input[type='submit'] {

  border-width: 0px;
}

.idb-salesforce-form input[type='submit'] {

  background-color: var(--salesforce-blue);
}

.idb-salesforce-form input[type='submit'] {

  font-size: var(--fs-2xl);

  line-height: var(--lh-2xl);
}

.idb-salesforce-form input[type='submit'] {

  text-transform: capitalize;
}

.idb-salesforce-form > div > label, .idb-salesforce-form span, .idb-salesforce-form .captcha {

  font-size: var(--fs-2xl);

  line-height: var(--lh-2xl);
}

.idb-salesforce-form > div > label, .idb-salesforce-form span, .idb-salesforce-form .captcha {

  text-transform: capitalize;
}

.idb-salesforce-form > div > label, .idb-salesforce-form span, .idb-salesforce-form .captcha {

  color: var(--salesforce-blue);
}

.idb-salesforce-form #edit-consent-disclosure, .idb-salesforce-form #edit-grievance-options {

  line-height: 2.5rem;
}

.autosubmit .form-actions, .autosubmit [type='submit'] {

  display: none;
}

.autosubmit .form-item {

  margin-bottom: 0px;
}

:host([is-expanded="true"]) form .form-chat {

  display: flex;
}

:host([is-expanded="true"]) form .form-chat {

  align-items: stretch;
}

:host([is-expanded="true"]) form .form-chat {

  justify-content: space-between;
}

:host([is-expanded="true"]) form .form-chat input {

  width: 310px;
}
`;